<template>
</template>

<script>
	export default{
		data(){
			
			this.$router.push({
				path: '/newSchoolProgramme',
				query: {
					programme: this.$route.query.programme
				}
			})
			return{
				
			}
		},
		methods:{
			
		}
	}
</script>

<style>
</style>
